import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-109">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="space-y-6" data-id="element-110">
        <h3 className="font-serif text-4xl md:text-5xl text-brand-light leading-tight" data-id="element-111">
          El Método de los <br data-id="element-112" />
          <span className="text-brand-accent italic" data-id="element-113">Micro-Momentos</span>{' '}
          <br data-id="element-114" />
          de Conexión Sensorial.
        </h3>

        <div className="w-12 h-1 bg-brand-accent/50 rounded-full my-8" data-id="element-115"></div>

        <p className="text-lg text-brand-light/80 leading-relaxed font-light" data-id="element-116">
          Este sistema no requiere citas de cuatro horas ni cenas costosas. Se
          basa en aprovechar las "ventanas invisibles" de 3 minutos durante el
          día para calmar el sistema nervioso de tu pareja, liberar oxitocina y
          mantener el deseo en modo "reactivo" para que la conexión sea
          inevitable, no forzada.
        </p>
      </motion.div>
    </section>;
}